import BasicUserInfo from "../BasicUserInfo";
import LastReplyUser from "../LastReplyUser";

const TOPIC_TITLE_LENGTH_MAX = 100;

function TopicItem({
  nightMode,
  topic,
  searchParams,
  setSearchParams,
  mutedUsers,
}) {
  const title =
    topic.topicTitle.length <= TOPIC_TITLE_LENGTH_MAX + 3
      ? topic.topicTitle
      : topic.topicTitle.slice(0, TOPIC_TITLE_LENGTH_MAX) + "...";
  let lastReplyUserId;
  if (topic.lastReplyUserId && topic.createdDate && topic.lastReplyDate) {
    if (
      Math.abs(topic.createdDate.seconds - topic.lastReplyDate.seconds) > 25
    ) {
      lastReplyUserId = topic.lastReplyUserId;
    }
  }
  return (
    <div
      className={
        "topic-container--new" + (nightMode ? " topic-container--new-dark" : "")
      }
      role="button"
    >
      <div className="flex justify-content--center align-items--center">
        {topic.userId ? (
          <BasicUserInfo
            userId={topic.userId}
            isTiny={true}
            truncateName={false}
            nightMode={nightMode}
          />
        ) : (
          <div></div>
        )}
      </div>
      <a
        className="topic-clickable-container align-self--center"
        role="button"
        href={"/forum?page=topic&topicId=" + topic.topicId}
      >
        <p className="description--large bold">{title}</p>
        {topic?.numberOfComments &&
        topic.numberOfComments > 1 &&
        lastReplyUserId ? (
          <p className="description--smaller text-align-left mobile-smaller-text align-self--start">
            {"Comments: " + (topic.numberOfComments - 1).toString(10)}
          </p>
        ) : null}
      </a>
      <div
        className={
          "cursor--pointer flex flex--direction-column forum-last-comment " +
          "justify-content--end align-items--end break-long-words"
        }
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          // normal left click
          const params = searchParams;
          searchParams.set("topicId", topic.topicId);
          searchParams.set("page", "topic");
          if (topic.pagination?.length) {
            const lastPage = topic.pagination.length.toString(10);
            const index = topic.pagination[topic.pagination.length - 1].index;
            searchParams.set("repliesNum", lastPage);
            searchParams.set("repliesIndex", index);
          } else {
            searchParams.set("repliesNum", "1");
          }
          setSearchParams(params);
        }}
      >
        {lastReplyUserId ? (
          <LastReplyUser
            nightMode={nightMode}
            userId={lastReplyUserId}
            firstText={""}
            secondText={"Last comment by: "}
            date={topic.lastReplyDate ? topic.lastReplyDate : null}
            isTiny={true}
            truncateName={true}
            mutedUsers={mutedUsers}
          />
        ) : (
          <p className="description--smaller text-align-right">
            Be the first to join this discussion!
          </p>
        )}
      </div>
    </div>
  );
}

export default TopicItem;
